/**
 * @fileOverView
 * @description Developer Page View<br>
 * @copyright 2015-present Flatirontek LLC
 **/

var DeveloperPageTemplate = require('../../templates/pages/developerpage.html');
var AmpersandView = require('ampersand-view');
var HeaderView = require('../widgets/header');
var FooterView = require('../widgets/footer');
var DeveloperFullView = require('../widgets/developerfullview');
var app = require('ampersand-app');

var DeveloperPageView = AmpersandView.extend({

    initialize: function(options) {
        if (!this.model) this.model = options && options.model ? options.model : new app.Developer();
        app.developer = this.model;
    },

    template: DeveloperPageTemplate,

    pageName: "DeveloperPage",

    subviews: {
        mpheader: {
            selector: 'header',
            prepareView: function(el) {
                app.currentPageName = this.pageName;
                return new HeaderView({
                    el: el,
                    parent: this,
                    maintitle: 'Developer'
                });
            }
        },

        mpfooter: {
            selector: 'footer',
            prepareView: function(el) {
                return new FooterView({
                    el: el,
                    parent: this
                });
            }
        },

        developer: {
            selector: '#content',
            prepareView: function(el) {
                return new DeveloperFullView({
                    el: el,
                    parent: this,
                    model: this.model
                });
            }
        }
    }

});

module.exports = DeveloperPageView;